<template>
  <button
    :class="[
      'own-button',
      `own-button--variant-${variant}`,
      {
        'own-button--small': small,
        'own-button--active': active,
        'own-button--icon-only': !text,
        'own-button--processing': processing,
        'own-button--disabled': disabled,
      },
    ]"
    :disabled="disabled"
    :type="type"
    @click.stop="onClick"
  >
    <template v-if="processing">
      <PhCircleNotch class="own-button__icon-loading" size="21" />
    </template>

    <template v-else>
      <span v-if="$slots['icon-left']" class="own-button__icon">
        <slot name="icon-left" />
      </span>

      <span
        v-if="text"
        :class="[
          'text-button-regular',
          {
            'text--truncate': textTruncate,
            'own-button__text--icon-left': $slots['icon-left'],
            'own-button__text--icon-right': $slots['icon-right'],
          },
        ]"
        v-text="text"
      ></span>

      <span v-if="$slots['icon-right']" class="own-button__icon">
        <slot name="icon-right" />
      </span>
    </template>
  </button>
</template>

<script lang="ts" setup>
import { PhCircleNotch } from '@phosphor-icons/vue'

const props = withDefaults(
  defineProps<{
    active?: boolean
    disabled?: boolean
    processing?: boolean
    small?: boolean
    text?: string
    textTruncate?: boolean
    type?: 'button' | 'submit' | 'reset'
    variant?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger'
  }>(),
  {
    active: false,
    disabled: false,
    processing: false,
    small: false,
    text: undefined,
    textTruncate: false,
    type: 'button',
    variant: 'secondary',
  }
)

const emit = defineEmits<{
  click: [data: MouseEvent]
}>()

const onClick = (event: MouseEvent) => {
  if (!props.processing) {
    emit('click', event)
  }
}
</script>

<style lang="scss" scoped src="./_own-button.scss" />
